<div class="d-flex align-items-center flex-wrap gap-2">
    @for (annotation of sortedAnnotations(); track annotation.label.text) {
    <div class="label-pill">
        <fa-icon
            [icon]="faSearch"
            class="label-icon"
            [ngbTooltip]="getTooltipText(annotation)"
            placement="top"
        >
        </fa-icon>
        <span class="label-text">{{ annotation.label.text }}</span>
    </div>
    } @empty {
    <i class="text-muted" i18n>No labels attached to this problem yet</i>
    }
    @if (canManageLabels$ | async) {
        <button
            type="button"
            class="btn btn-sm btn-outline-primary manage-button"
            (click)="openManageLabelsModal()"
            i18n
        >
            Manage labels
        </button>
    }
</div>
